import { render, staticRenderFns } from "./CrmDialog.vue?vue&type=template&id=8666f188&scoped=true"
import script from "./CrmDialog.vue?vue&type=script&lang=js"
export * from "./CrmDialog.vue?vue&type=script&lang=js"
import style0 from "./CrmDialog.vue?vue&type=style&index=0&id=8666f188&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8666f188",
  null
  
)

export default component.exports